(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-contact-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefillProduct = () => {
      const message = document.querySelector('#OwContactMessage');
      if (!message || message.value.trim()) return;
      const product = new URLSearchParams(window.location.search).get('product');
      if (!product) return;
      const title = product.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 240);
      if (title) message.value = `${title}\n\n`;
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prefillProduct, { once: true });
    } else {
      prefillProduct();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
